import Image from 'next/image';
import styled from 'styled-components';
export const Wrapper = styled.div<{
  $backgroundImage: string;
}>`
  background-size: cover !important;
  background-image: ${({
  $backgroundImage
}) => $backgroundImage ? `url(${$backgroundImage})` : 'none'};
  padding-bottom: 0;
  height: 100%;
  flex-grow: 1;
`;
export const Header = styled.div`
  max-width: 630px;
  width: 100%;
  margin: 15px auto 25px;

  @media screen and (min-width: 1441px) {
    max-width: 700px;
  }
`;
export const Logo = styled(Image)`
  display: block;
  margin: 0 auto 10px;
  max-width: 95px;
  width: 100%;
  height: auto;

  @media screen and (min-width: 1441px) {
    max-width: 120px;
  }
`;